export default __webpack_public_path__ + "static/media/suitability-check.17302551.png";